import { getRef } from './referral';

const API = process.env.REACT_APP_BACKEND_URL;

export async function fetchPaymentOptions() {
  const r = await fetch(`${API}/api/payments/links`);
  return r.json();
}

async function startCheckout(path, product) {
  const r = await fetch(`${API}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ product, origin_url: window.location.origin, ref_code: getRef() || null }),
  });
  const d = await r.json();
  if (!d.url) throw new Error('no checkout url');
  window.location.href = d.url;
}

export const startStripeCheckout = (product) => startCheckout('/api/payments/checkout/session', product);
export const startPaypalCheckout = (product) => startCheckout('/api/payments/paypal/subscription', product);

export function stripeLinkWithRef(link) {
  return `${link}${link.includes('?') ? '&' : '?'}client_reference_id=${encodeURIComponent(getRef() || 'DIRECT')}`;
}
